import { STATS_CORNER_MESSAGE } from "@/src/constants/StatsCornerConstants";
import { isA23 } from "../Stats";
import styles from "../Stats.module.css";

const LineChartLoader = () => {
  return (
    <div className="vpip-pfr-section gap-3 mb-3">
      <div
        className={`flex flex-col justify-between h-65 ${styles.cardConfig} gap-1`}
      >
        <div className={`flex justify-center h-6 w-full`}>
          <div
            className={`bg-accent rounded-[3px] w-20 ${styles.shimmerD}`}
          ></div>
        </div>
        <div className="flex justify-center">
          <div className={` ${styles.skeletonCoordinate}`}></div>
        </div>
        <div className="flex justify-center">
          <div
            className={`h-4 w-65 ml-6.25 ${styles.shimmerD} bg-accent rounded`}
          ></div>
        </div>
        <div className={`flex ${isA23 ? "justify-end" : "justify-center"}`}>
          <div className={`h-2 w-22 ${styles.shimmerD} bg-accent rounded`} />
        </div>
      </div>
    </div>
  );
};

const RadialLoader = () => {
  return (
    <div className="vpip-pfr-section grid grid-cols-2 gap-3 mt-3">
      <div className={`flex flex-col ${styles.cardConfig} h-32`}>
        <div className="h-[16px] shimmerD w-[30px] bg-accent mb-2 rounded-[3px]"></div>
        <div className="h-[12px] shimmerD w-[120px] bg-accent rounded-[3px] mb-3"></div>
        <div className="place-self-end h-[58px] shimmerD w-[58px] bg-accent rounded-[3px]"></div>
      </div>
      <div className={`flex flex-col ${styles.cardConfig} h-[128px]`}>
        <div
          className={`h-[16px] ${styles.shimmerD} w-[30px] bg-accent mb-2 rounded-[3px]`}
        ></div>
        <div
          className={`h-[12px] ${styles.shimmerD} w-[120px] bg-accent rounded-[3px] mb-3`}
        ></div>
        <div
          className={`place-self-end h-[58px] ${styles.shimmerD} w-[58px] bg-accent rounded-[3px]`}
        ></div>
      </div>
    </div>
  );
};

const ProgressLoader = () => {
  return (
    <div
      className={`${styles.coreCardConfigBkGradient} py-3 px-3 mt-3 h-[52px]`}
    >
      <div className="flex justify-between mb-2">
        <div
          className={`h-[16px] ${styles.shimmerD} w-[30px] bg-accent rounded-[3px]`}
        ></div>
        <div
          className={`h-[16px] ${styles.shimmerD} w-[120px] bg-accent rounded-[3px]`}
        ></div>
      </div>
      <div
        className={`h-[6px] w-full ${styles.shimmerD} bg-background rounded-full`}
      ></div>
    </div>
  );
};

const RadialLoader2 = () => {
  return (
    <div
      className={`${styles.coreCardConfigBkGradient} py-4 px-4 mt-3 h-[110px]`}
    >
      <div className="flex justify-between mb-2">
        <div>
          <div
            className={`h-[44px] w-[44px] ${styles.shimmerD} bg-accent rounded-full mb-4`}
          ></div>
          <div
            className={`h-[16px] w-[44px] ${styles.shimmerD} bg-accent rounded-[3px]`}
          ></div>
        </div>
        <div>
          <div
            className={`h-[44px] w-[44px] ${styles.shimmerD} bg-accent rounded-full mb-4`}
          ></div>
          <div
            className={`h-[16px] w-[44px] ${styles.shimmerD} bg-accent rounded-[3px]`}
          ></div>
        </div>
        <div>
          <div
            className={`h-[44px] w-[44px] ${styles.shimmerD} bg-accent rounded-full mb-4`}
          ></div>
          <div
            className={`h-[16px] w-[44px] ${styles.shimmerD} bg-accent rounded-[3px]`}
          ></div>
        </div>
        <div>
          <div
            className={`h-[44px] w-[44px] ${styles.shimmerD} bg-accent rounded-full mb-4`}
          ></div>
          <div
            className={`h-[16px] w-[44px] ${styles.shimmerD} bg-accent rounded-[3px]`}
          ></div>
        </div>
      </div>
    </div>
  );
};

const PlayMessageBorder = () => {
  return (
    <div
      className={`border-t-[0.0313rem] ${
        isA23 ? "border-(--teal-700)" : "border-b-main"
      } rounded-t-xl`}
    >
      <div
        className={`text-xs font-normal text-primary pt-2.5 flex justify-center gap-1.5`}
      >
        <div className={`${styles.shimmerD} rounded-[3px] h-4 w-70`}></div>
      </div>
    </div>
  );
};

const StealCheckRaiseSkeleton = ({ count = 2 }) => {
  return (
    <div className="steal-check-raise grid grid-cols-2 gap-3 mt-3">
      {[...Array(count)].map((_, i) => (
        <div key={i}>
          <div
            className={`flex flex-col ${styles.coreCardConfigBkGradient} py-4.25 px-3 gap-1.25 h-15.5`}
          >
            <div className="flex justify-between">
              <div className={`h-4 w-8 ${styles.shimmerD} bg-accent rounded`} />
              <div className={`h-4 w-8 ${styles.shimmerD} bg-accent rounded`} />
            </div>
            <div
              className={`h-1.5 w-full ${styles.shimmerD} bg-background rounded-full`}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

const PerformanceGridSkeleton = ({ title = "", count = 5 }) => {
  const parentContainerClass = isA23
    ? styles.statsPerformance
    : styles.statsAddaPerformance;
  const childContainerClass = isA23 ? styles.statCard : "flex flex-col";
  return (
    <div className="mt-[24px]">
      <div className={`h-5 w-40 mb-3 rounded-[3px] ${styles.shimmerD}`}></div>
      <div className={parentContainerClass}>
        {[...Array(count)].map((_, i) => (
          <div key={i} className={childContainerClass}>
            <div
              className={`bg-muted h-5 w-1/2 rounded mb-2 ${styles.shimmerD}`}
            />
            <div className={`bg-muted h-4 w-1/3 rounded ${styles.shimmerD}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const StatsLoader = ({ type }) => {
  const gameType = type?.gameType;
  return gameType == "CASH" ? (
    <>
      <PlayMessageBorder />
      <RadialLoader />
      <ProgressLoader />
      <RadialLoader2 />
      <StealCheckRaiseSkeleton />
      <PerformanceGridSkeleton title="Cash Game Performance" />
    </>
  ) : (
    <>
      <LineChartLoader />
      <PlayMessageBorder />
      <RadialLoader />
      <ProgressLoader />
      <RadialLoader2 />
      <StealCheckRaiseSkeleton />
    </>
  );
};
